import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import { Selector } from '@leverege/ui-elements';
import { TextInput, Flex, InsetSection, JsonEditorDialog, LabelGroup, Section } from '~/views';

import style from './style.css'
import { registry } from './Factory'

const methods = [
  { value : 'GET' },
  { value : 'POST' },
  { value : 'PATCH' },
  { value : 'PUT' },
  { value : 'DELETE' },
]

export default class QueryUrlEditor extends React.Component {
  static TYPE = 'queryUrl';

  static NAME = 'Query Url';

  static DEFAULTS = {
    type : 'queryUrl',
    url : 'https://www.somefake.url',
    method : 'GET'
  }

  constructor( props ) {
    super( props )
    this.state = {
      showDialog : false
    }
  }

  changePath = ( path, value, err ) => {
    if ( err ) {
      console.log( `error setting ${path} to ${value}`, err )
      this.props.onError( path, value, err )
      return
    }
    if ( typeof this.props.onChange === 'function' ) {
      this.props.onChange( { target : this.props.timer, path, value } );
    }
  }

  render() {
    // this.baseTimer.changePath( 'timer/when', v, err )
    const { timer } = this.props
    const { showDialog } = this.state

    const actionObj = timer.action

    const types = Object.keys( registry ).map( ( value ) => {
      return { value, name : registry[value].NAME }
    } )

    const actionOptions = JSON.parse( JSON.stringify( actionObj ) )
    delete actionOptions.url
    delete actionOptions.method
    delete actionOptions.type
    
    return (
      <div>
        <Section title="Action">
          <Flex variant="vSpace" align="stretch" direction="column">
            <LabelGroup>
              <label>Type</label>
              <Selector
                values={types}
                value={actionObj.type}
                onChange={( value ) => { this.changePath( 'action/type', value.value, false ); }} />
            </LabelGroup>
            <LabelGroup>
              <label>URL</label>
              <TextInput
                value={actionObj.url}
                changeOnReturn
                size={10}
                onChange={value => this.changePath( 'action/url', value, false )} />
            </LabelGroup>
            <LabelGroup>
              <label>Method</label>
              <Selector
                valueKey="value"
                nameKey="value"
                values={methods}
                value={actionObj.method}
                onChange={( value ) => { this.changePath( 'action/method', value.value, false ); }} />
            </LabelGroup>
            <LabelGroup vertical>
              <label>Options</label>
              <InsetSection style={{ width : '100%' }}>
                <div className={style.metadata}>{JSON.stringify( actionOptions )}</div> 
                <Button style={{ float : 'right' }} bsSize="sm" onClick={() => { this.setState( { showDialog : true } ) }}>Edit</Button>
              </InsetSection>
            </LabelGroup>
            <JsonEditorDialog 
              title="Action Options"
              message="Enter the JSON object for the query options"
              show={showDialog} 
              onOk={( val ) => { 
                console.log( val )
                val.url = actionObj.url
                val.method = actionObj.method
                val.type = QueryUrlEditor.TYPE

                this.changePath( 'action', val, false )
                this.setState( { showDialog : false } ) 
              }}
              onCancel={() => { this.setState( { showDialog : false } ) }}
              value={actionOptions} />
          </Flex>
        </Section>
      </div>
    )
  }
}
